import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {XcoLoa} from '../models/xcoLoa';

@Injectable()
export class XcoService {

  constructor(private httpClient: HttpClient) {
  }

  getAllXcos(clientUuid: string): Observable<XcoLoa[]> {
    return this.httpClient.get<XcoLoa[]>(environment.baseUrlWs + '/api/cross-connects?company=' + clientUuid);
  }

  changeClientRef(id, newClientRef: string) {
    return this.httpClient.put<XcoLoa>(environment.baseUrlWs + '/api/cross-connects/' + id, {'ref': newClientRef});
  }
}
